import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '~/contexts/AuthContext';
import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';

interface PrivateRouteProps {
  children?: React.ReactNode;
  navigateTo: string; // Default to "/spa-layout" if not specified
  from?: string; // Default to root path "/" if not specified
  authenticated?: boolean;
}

const Loading: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full viewport height
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  authenticated = false,
  navigateTo,
  from,
}) => {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) return <Loading />;

  if (authenticated && isAuthenticated) {
    if (from === location.pathname) {
      return <Navigate to={navigateTo} replace />;
    }
  } else if (!authenticated && !isAuthenticated) {
    if (navigateTo) {
      return <Navigate to={navigateTo} state={{ from: location }} replace />;
    }
  }

  return children ? <>{children}</> : <Outlet />;
};
